"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatAnchor = void 0;
var react_1 = require("@headlessui/react");
var solid_1 = require("@heroicons/react/20/solid");
var react_2 = __importStar(require("react"));
require("../../../index.css");
var ChatAnchor = /** @class */ (function (_super) {
    __extends(ChatAnchor, _super);
    function ChatAnchor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            chatBaseVisible: false,
        };
        _this.renderChatAnchorIcon = function (chatBaseVisible) {
            if (chatBaseVisible) {
                return react_2.default.createElement(solid_1.XMarkIcon, { className: "w-8 h-8", color: "white" });
            }
            else {
                return react_2.default.createElement(solid_1.ChatBubbleOvalLeftIcon, { className: "w-8 h-8", color: "white" });
            }
        };
        return _this;
    }
    ChatAnchor.prototype.render = function () {
        var _this = this;
        return (react_2.default.createElement("div", { className: "relative w-fit h-fit" },
            react_2.default.createElement("div", { className: "fixed flex flex-col items-end space-y-4 bottom-8 right-8" },
                react_2.default.createElement(react_1.Transition, { show: this.state.chatBaseVisible, as: react_2.Fragment, enter: "transform transition duration-[400ms]", enterFrom: "opacity-0 scale-50", leave: "transform duration-200 transition ease-in-out", leaveTo: "opacity-0 scale-95 " },
                    react_2.default.createElement("div", null, this.props.chatBase)),
                react_2.default.createElement("div", { onClick: function () {
                        return _this.setState({ chatBaseVisible: !_this.state.chatBaseVisible });
                    }, className: "p-4 rounded-full select-none h-fit w-fit bg-primary-500 hover:cursor-pointer hover:bg-primary-600" }, this.renderChatAnchorIcon(this.state.chatBaseVisible)))));
    };
    return ChatAnchor;
}(react_2.Component));
exports.ChatAnchor = ChatAnchor;
//# sourceMappingURL=index.js.map